import React, { useState, useEffect, useMemo, useRef } from 'react';
import CommodityRulesStyled from './CommodityRulesStyled';
import {
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Checkbox,
  InputAdornment,
  useTheme,
  Button,
  Input,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useIntl } from 'umi';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'dva';
import DataTableNativeML from '@/components/DataTableNativeML';
import DialogML from '@/components/DialogML';
import CouponModal from '../../coupon_modal/CouponModal';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import ChooseCoupon from '../member_level/choose_coupon/ChooseCoupon';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import {
  download,
  uploadExcel,
  downLoadPrivateFile,
} from '@/utils/downloadUtil';
import { CheckBoxFieldCom, TextFieldCom } from '@/components/FormType';
import Loading from '@/components/loading_ml/Loading';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="tab-content"
      {...other}
    >
      {value === index && (
        <Box style={{ overflowX: 'hidden' }} className="content-wrapper">
          {children}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    dataId,
    // productRulesList,
    hasProductRule,
    setHasProductRule,
    orderBenefitType,
    setOrderBenefitType,
    setProductRulesList,
    opt,
    // skuProduct,
    setIsSave,
    orderAmountLimit,
    setFormValue,
    getValues,
    errors,
    watch,
    control,
  } = props;

  useEffect(() => {
    console.log(orderAmountLimit, 'orderAmountLimit');
    setFormValue('orderAmountLimit', orderAmountLimit);
    let checkValue = orderAmountLimit > 0 ? ['1'] : [];
    setFormValue('paidAmountCheckbox', checkValue);
  }, [orderAmountLimit]);

  const itemCoupons = useSelector((state) => state.sceneMarketing?.allCoupons);

  // const [arr, ...rest] = productRulesList;
  const [type] = useState();
  const [modify, setModify] = useState({});
  const [dialogStatus, setDialogStatus] = useState(false); //选中门店model的状态
  const [productsChooseDataId, setProductsChooseDataId] = useState([]); //选中的门店Id
  const [productsChooseItemData, setProductsChooseItemData] = useState([]);
  const [productsChooseItemDataSeries, setProductsChooseItemDataSeries] =
    useState([]); //存储所有选中数据列
  const [productsChooseDataIdSeries, setProductsChooseDataIdSeries] = useState(
    [],
  ); //选中的门店Id
  const [productsChooseItemDataSeason, setProductsChooseItemDataSeason] =
    useState([]); //存储所有选中数据列
  //Season
  const [productsChooseDataIdSeason, setProductsChooseDataIdSeason] = useState(
    [],
  );
  //选中的门店Id
  const [productsChooseItemDataSubclass, setProductsChooseItemDataSubclass] =
    useState([]); //存储所有选中数据列
  //Subclass
  const [productsChooseDataIdSubclass, setProductsChooseDataIdSubclass] =
    useState([]); //选中的门店Id
  //选中的门店Id
  const [productsChooseItemDataDesign, setProductsChooseItemDataDesign] =
    useState([]); //存储所有选中数据列
  //Subclass
  const [productsChooseDataIdDesign, setProductsChooseDataIdDesign] = useState(
    [],
  ); //选中的门店Id
  //Category
  const [productsChooseDataIdCategory, setProductsChooseDataIdCategory] =
    useState([]); //选中的门店Id
  const [productsChooseItemDataCategory, setProductsChooseItemDataCategory] =
    useState([]); //存储所有选中数据列
  const [productsChooseItemShowIdData, setProductsChooseItemShowIdData] =
    useState([]); //选中的门店点确定后的值Id
  const [
    productsChooseItemShowIdDataSeries,
    setProductsChooseItemShowIdDataSeries,
  ] = useState([]); //选中的门店点确定后的值Id
  // 选中后的商品展示
  const [productsChooseItemShowData, setProductsChooseItemShowData] = useState(
    [],
  );
  //选中的门店点确定后的值列
  const [
    productsChooseItemShowDataSeries,
    setProductsChooseItemShowDataSeries,
  ] = useState([]); //选中的门店点确定后的值列
  const [
    productsChooseItemShowDataSeason,
    setProductsChooseItemShowDataSeason,
  ] = useState([]); //选中的门店点确定后的值列
  const [
    productsChooseItemShowIdDataSeason,
    setProductsChooseItemShowIdDataSeason,
  ] = useState([]); //选中的门店点确定后的值Id
  const [
    productsChooseItemShowDataSubclass,
    setProductsChooseItemShowDataSubclass,
  ] = useState([]); //选中的门店点确定后的值列
  const [
    productsChooseItemShowIdDataSubclass,
    setProductsChooseItemShowIdDataSubclass,
  ] = useState([]); //选中的门店点确定后的值Id
  const [
    productsChooseItemShowDataDesign,
    setProductsChooseItemShowDataDesign,
  ] = useState([]); //选中的门店点确定后的值列
  const [
    productsChooseItemShowIdDataDesign,
    setProductsChooseItemShowIdDataDesign,
  ] = useState([]); //选中的门店点确定后的值Id
  const [
    productsChooseItemShowDataCategory,
    setProductsChooseItemShowDataCategory,
  ] = useState([]); //选中的门店点确定后的值列
  const [
    productsChooseItemShowIdDataCategory,
    setProductsChooseItemShowIdDataCategory,
  ] = useState([]); //选中的门店点确定后的值Id
  const [
    productsChooseItemShowIdDataStyles,
    setProductsChooseItemShowIdDataStyles,
  ] = useState([]); //选中的门店点确定后的值Id
  // 款式
  const [
    productsChooseItemShowDataStyles,
    setProductsChooseItemShowDataStyles,
  ] = useState([]);

  const [
    productsChooseItemShowIdDataGoods,
    setProductsChooseItemShowIdDataGoods,
  ] = useState([]);

  const [productsChooseDataIdStyles, setProductsChooseDataIdStyles] = useState(
    [],
  ); //选中的门店Id

  const [productsChooseItemDataStyles, setProductsChooseItemDataStyles] =
    useState([]);
  const [productsChooseDataIdGoods, setProductsChooseDataIdGoods] = useState(
    [],
  );
  const [productsChooseItemDataGoods, setProductsChooseItemDataGoods] =
    useState([]);

  const [productsChooseItemShowDataGoods, setProductsChooseItemShowDataGoods] =
    useState([]);

  // 默认的优惠券列表
  const [commCoupons, setCommCoupons] = useState([]);
  const [couponOpen, setCouponOpen] = useState(false);
  const [newCouponOpen, setNewCouponOpen] = useState(false);

  const couponIds = useSelector((state) => state.sceneMarketing?.couponIds);
  const skuProduct = useSelector((state) => state.sceneMarketing?.skuProduct);
  const seriesProduct = useSelector(
    (state) => state.sceneMarketing?.seriesProduct,
  );
  const stylesProduct = useSelector(
    (state) => state.sceneMarketing?.stylesProduct,
  );
  const goodsProduct = useSelector(
    (state) => state.sceneMarketing?.goodsProduct,
  );
  const reasonProduct = useSelector(
    (state) => state.sceneMarketing?.reasonProduct,
  );
  const subclassProduct = useSelector(
    (state) => state.sceneMarketing?.subclassProduct,
  );
  const designProduct = useSelector(
    (state) => state.sceneMarketing?.designProduct,
  );
  const categoryProduct = useSelector(
    (state) => state.sceneMarketing?.categoryProduct,
  );

  // 批量导入dialog状态
  const [batchImportOpen, setBatchImportOpen] = useState(false);
  //批量上传的input
  const inputUploadExcelRef = useRef();
  //批量导入成功失败的状态监听,ready=>打开导入弹框，start=>点击上传文件按钮，success=>成功，fail=>失败，warning=>有成功有失败
  const [importStatus, setImportStatus] = useState('ready');
  //存储上传成功的数据
  const [uploadSuccessData, setUploadSuccessData] = useState(null);
  //监听批量导入的状态
  const [importFetchStatus, setImportFetchStatus] = useState();

  useEffect(() => {
    const newArr = [...skuProduct];
    let defaultIds = []; //ids
    if (newArr.length > 0) {
      defaultIds = newArr.map((item) => item.id);
    }

    setProductsChooseDataId(defaultIds);
    setProductsChooseItemShowIdData(defaultIds);
    setProductsChooseItemData(newArr);
    setProductsChooseItemShowData(newArr);

    let defaultIdsSeries = []; //ids
    const seriesArr = [...seriesProduct];
    if (seriesArr.length > 0) {
      defaultIdsSeries = seriesArr.map((item) => item.addTypeName);
    }
    setProductsChooseDataIdSeries(defaultIdsSeries);
    setProductsChooseItemShowIdDataSeries(defaultIdsSeries);
    setProductsChooseItemDataSeries(seriesArr);
    setProductsChooseItemShowDataSeries(seriesArr);

    let defaultIdsStyles = [];
    const stylesArr = [...stylesProduct];
    if (stylesArr.length > 0) {
      defaultIdsStyles = stylesArr.map((item) => item.addTypeName);
    }
    setProductsChooseDataIdStyles(defaultIdsStyles);
    setProductsChooseItemShowIdDataStyles(defaultIdsStyles);
    setProductsChooseItemDataStyles(stylesArr);
    setProductsChooseItemShowDataStyles(stylesArr);

    let defaultIdsGoods = [];
    const goodsArr = [...goodsProduct];
    if (goodsArr.length > 0) {
      defaultIdsGoods = goodsArr.map((item) => item.addTypeName);
    }
    setProductsChooseDataIdGoods(defaultIdsGoods);
    setProductsChooseItemShowIdDataGoods(defaultIdsGoods);
    setProductsChooseItemDataGoods(goodsArr);
    setProductsChooseItemShowDataGoods(goodsArr);

    let defaultIdsSeason = []; //ids
    const seasonArr = [...reasonProduct];
    if (seasonArr.length > 0) {
      defaultIdsSeason = seasonArr.map((item) => item.id);
    }
    setProductsChooseDataIdSeason(defaultIdsSeason);
    setProductsChooseItemShowIdDataSeason(defaultIdsSeason);
    setProductsChooseItemDataSeason(seasonArr);
    setProductsChooseItemShowDataSeason(seasonArr);

    let defaultIdsSubclass = []; //ids
    const subclassArr = [...subclassProduct];
    if (subclassArr.length > 0) {
      defaultIdsSubclass = subclassArr.map((item) => item.id);
    }
    setProductsChooseDataIdSubclass(defaultIdsSubclass);
    setProductsChooseItemShowIdDataSubclass(defaultIdsSubclass);
    setProductsChooseItemDataSubclass(subclassArr);
    setProductsChooseItemShowDataSubclass(subclassArr);

    let defaultIdsDesign = []; //ids
    const designArr = [...designProduct];
    if (designArr.length > 0) {
      defaultIdsDesign = designArr.map((item) => item.id);
    }
    setProductsChooseDataIdDesign(defaultIdsDesign);
    setProductsChooseItemShowIdDataDesign(defaultIdsDesign);
    setProductsChooseItemDataDesign(designArr);
    setProductsChooseItemShowDataDesign(designArr);

    let defaultIdsCategory = []; //ids
    const categoryArr = [...categoryProduct];
    if (categoryArr.length > 0) {
      defaultIdsCategory = categoryArr.map((item) => item.id);
    }
    setProductsChooseDataIdCategory(defaultIdsCategory);
    setProductsChooseItemShowIdDataCategory(defaultIdsCategory);
    setProductsChooseItemDataCategory(categoryArr);
    setProductsChooseItemShowDataCategory(categoryArr);
  }, [
    skuProduct,
    seriesProduct,
    stylesProduct,
    goodsProduct,
    reasonProduct,
    subclassProduct,
    designProduct,
    categoryProduct,
  ]);

  // 获取优惠券张数
  useMemo(() => {
    if (couponIds) {
      const arr = [...productsChooseItemShowData];
      const chooseProductDataCoupons = arr.filter((i) => i?.id === couponIds);
      chooseProductDataCoupons.forEach((item) => {
        let num = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          num =
            Number(num) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = num;
      });
      setProductsChooseItemShowData(arr);
      //系列产品
      const seriesArr = [...productsChooseItemShowDataSeries];
      const chooseSeriesProduct = seriesArr.filter(
        (i) => i?.addTypeName === couponIds,
      );
      // const newArr=[...chooseSeriesProduct];
      chooseSeriesProduct.forEach((item) => {
        let snum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          snum =
            Number(snum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = snum;
      });
      setProductsChooseItemShowDataSeries(seriesArr);
      // 款式产品
      const stylesArr = [...productsChooseItemShowDataStyles];
      const chooseStylesProduct = stylesArr.filter(
        (i) => i?.addTypeName === couponIds,
      );
      // const newArr=[...chooseSeriesProduct];
      chooseStylesProduct.forEach((item) => {
        let snum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          snum =
            Number(snum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = snum;
      });
      setProductsChooseItemShowDataStyles(stylesArr);
      // 货号产品
      const goodsArr = [...productsChooseItemShowDataGoods];
      const chooseGoodsProduct = goodsArr.filter(
        (i) => i?.addTypeName === couponIds,
      );
      // const newArr=[...chooseSeriesProduct];
      chooseGoodsProduct.forEach((item) => {
        let snum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          snum =
            Number(snum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = snum;
      });
      setProductsChooseItemShowDataGoods(goodsArr);
      // 季节产品
      const seasonArr = [...productsChooseItemShowDataSeason];
      const chooseSeasonProduct = seasonArr.filter(
        (i) => i?.addTypeName === couponIds,
      );
      // const newSeason=[...chooseSeasonProduct];
      chooseSeasonProduct.forEach((item) => {
        let senum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          senum =
            Number(senum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = senum;
      });
      setProductsChooseItemShowDataSeason(seasonArr);
      // 配件
      const subArr = [...productsChooseItemShowDataSubclass];
      const chooseSubClass = subArr.filter((i) => i?.addTypeName === couponIds);
      // const subData=[...chooseSubClass];
      chooseSubClass.forEach((item) => {
        let subnum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          subnum =
            Number(subnum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = subnum;
      });
      setProductsChooseItemShowDataSubclass(subArr);
      // 款式
      const desArr = [...productsChooseItemShowDataDesign];
      const chooseDesign = desArr.filter((i) => i?.addTypeName === couponIds);
      // const subData=[...chooseSubClass];
      chooseDesign.forEach((item) => {
        let desnum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          desnum =
            Number(desnum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = desnum;
      });
      setProductsChooseItemShowDataDesign(desArr);
      //类别
      const cateArr = [...productsChooseItemShowDataCategory];
      const chooseCategory = cateArr.filter(
        (i) => i?.addTypeName === couponIds,
      );
      chooseCategory.forEach((item) => {
        let canum = [];
        for (let i = 0; i < itemCoupons[couponIds]?.length; i++) {
          canum =
            Number(canum) + Number(itemCoupons[couponIds][i]?.couponCode || 0);
        }
        item['coupons'] = itemCoupons[couponIds];
        item['num'] = canum;
      });
      setProductsChooseItemShowDataCategory(cateArr);
    }
  }, [couponIds, dataId, itemCoupons, modify]);

  const {
    productsList,
    productsTotal,
    productsPageSize,
    productsPageNum,

    productsListSeries,
    productsTotalSeries,
    productsPageSizeSeries,
    productsPageNumSeries,
    // 款式产品
    productsListStyles,
    productsTotalStyles,
    productsPageSizeStyles,
    productsPageNumStyles,

    // 货号产品
    productsListGoods,
    productsTotalGoods,
    productsPageSizeGoods,
    productsPageNumGoods,

    productsListSeason,
    productsTotalSeason,
    productsPageSizeSeason,
    productsPageNumSeason,
    productsListSubclass,
    productsTotalSubclass,
    productsPageSizeSubclass,
    productsPageNumSubclass,
    productsListDesign,
    productsTotalDesign,
    productsPageSizeDesign,
    productsPageNumDesign,
    productsListCategory,
    productsTotalCategory,
    productsPageSizeCategory,
    productsPageNumCategory,
    // productsPageNumStyles,
    // productsPageSizeStyles,
  } = useSelector((state) => state.couponsSetting);

  useEffect(() => {
    setProductRulesList(
      productsChooseItemShowData
        ?.concat(productsChooseItemShowDataSeries)
        ?.concat(productsChooseItemShowDataSeason)
        ?.concat(productsChooseItemShowDataSubclass)
        ?.concat(productsChooseItemShowDataDesign)
        ?.concat(productsChooseItemShowDataCategory)
        ?.concat(productsChooseItemShowDataStyles)
        ?.concat(productsChooseItemShowDataGoods),
    );
  }, [
    productsChooseItemShowData,
    productsChooseItemShowDataCategory,
    productsChooseItemShowDataGoods,
    productsChooseItemShowDataSeason,
    productsChooseItemShowDataSeries,
    productsChooseItemShowDataStyles,
    productsChooseItemShowDataSubclass,
    productsChooseItemShowDataDesign,
    setProductRulesList,
  ]);
  // 需要将选中的商品回传
  // 回传时需要进行格式转换
  const [productName, setProductName] = useState();
  const [productSeriesNames, setProductSeriesNames] = useState();
  const [productStylesNames, setProductStylesNames] = useState();
  const [productGoodsNames, setProductGoodsNames] = useState();
  const [productSeasonNames, setProductSeasonNames] = useState();
  const [productSubclassNames, setProductSubclassNames] = useState();
  const [productDesignNames, setProductDesignNames] = useState();
  const [productCategoryName, setProductCategoryName] = useState();
  const loadingEffect = useSelector((state) => state.loading);
  const loading =
    loadingEffect.effects['couponsSetting/getProducts'] ||
    loadingEffect.effects['couponsSetting/getProductsSeries'] ||
    loadingEffect.effects['couponsSetting/getProductsStyle'] ||
    loadingEffect.effects['couponsSetting/getProductsGoods'] ||
    loadingEffect.effects['couponsSetting/getProductsSeason'] ||
    loadingEffect.effects['couponsSetting/getProductsSubclass'] ||
    loadingEffect.effects['couponsSetting/getProductsDesign'] ||
    loadingEffect.effects['couponsSetting/getProductsCategory'] ||
    loadingEffect.effects['couponsSetting/getProducts'];

  // 获取系列产品
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsSeries',
        payload: {
          value: {
            addType: 'SERIES',
            addTypeName: productSeriesNames,
            pageNum: productsPageNumSeries,
            pageSize: productsPageSizeSeries,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumSeries, productsPageSizeSeries]);

  // 获取款号产品
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsStyle',
        payload: {
          value: {
            addType: 'SPU',
            addTypeName: productStylesNames,
            pageNum: productsPageNumStyles,
            pageSize: productsPageSizeStyles,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumStyles, productsPageSizeStyles]);

  // 获取货号商品
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsGoods',
        payload: {
          value: {
            addType: 'MATERIAL_CODE',
            addTypeName: productGoodsNames,
            pageNum: productsPageNumGoods,
            pageSize: productsPageSizeGoods,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumGoods, productsPageSizeGoods]);

  // 获取季节产品
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsSeason',
        payload: {
          value: {
            addType: 'SEASON',
            addTypeName: productSeasonNames,
            pageNum: productsPageNumSeason,
            pageSize: productsPageSizeSeason,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumSeason, productsPageSizeSeason]);

  // 获取配件种类产品
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsSubclass',
        payload: {
          value: {
            addType: 'SUBCLASS',
            addTypeName: productSubclassNames,
            pageNum: productsPageNumSubclass,
            pageSize: productsPageSizeSubclass,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumSubclass, productsPageSizeSubclass]);
  // 获取款式
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsDesign',
        payload: {
          value: {
            addType: 'STYLE',
            addTypeName: productDesignNames,
            pageNum: productsPageNumDesign,
            pageSize: productsPageSizeDesign,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumDesign, productsPageSizeDesign]);

  // 获取分类产品
  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProductsCategory',
        payload: {
          value: {
            addType: 'GENERAL_CATEGORY',
            addTypeName: productCategoryName,
            pageNum: productsPageNumCategory,
            pageSize: productsPageSizeCategory,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNumCategory, productsPageSizeCategory]);

  // 获取商品列表

  useEffect(() => {
    !loading &&
      dispatch({
        type: 'couponsSetting/getProducts',
        payload: {
          value: {
            name: productName,
            pageNum: productsPageNum,
            pageSize: productsPageSize,
            sort: null,
          },
        },
      });
  }, [dispatch, productsPageNum, productsPageSize]);

  //  产品NO
  const columns = [
    {
      type: 'checkbox',
      width: '100',
      onChange: (a) => {
        const pageDataIds = productsList.map((item) => item.id); //当前分页的id数组
        const prevProductsChooseItemData = productsChooseItemData.filter(
          (item) => {
            //过滤掉当前页的选中列
            return pageDataIds.indexOf(item.id) === -1;
          },
        );
        let chooseDatas = productsList.filter((fItem) => {
          //当前选中的数据过滤出当前页的数据
          return a.includes(fItem.id);
        });
        chooseDatas.forEach((element) => {
          element['type'] = 'SKU';
          element['content'] = element['name'];
        });
        const newListData = [...prevProductsChooseItemData, ...chooseDatas];
        //将选中的数据a替换老数据
        // setProductsChooseDataId(a);
        const newIdsData = newListData.map((item) => item.id);
        //将选中的数据a替换老数据
        setProductsChooseDataId(newIdsData);
        setProductsChooseItemData(newListData);
      },
    },
    {
      // title: '编码',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl01' }),
      id: 'productNo',
      align: 'center',
      width: 347,
    },
    {
      // title: '名称',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl02' }),
      id: 'name',
      align: 'center',
      width: 347,
      render: (item) => {
        return <Box textAlign="center">{item.name}</Box>;
      },
    },
  ];

  const [valueChoose, setTabValueChoose] = React.useState(0);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    switch (value) {
      case 0:
        onHandleClickSearchProductsStyles();
        break;
      case 1:
        onHandleClickSearchProductsGoods();
        break;
      case 2:
        onHandleClickSearchProducts();
        break;
      case 3:
        onHandleClickSearchProductsSeries();
        break;
      case 4:
        onHandleClickSearchProductsSeason();
        break;
      case 5:
        onHandleClickSearchProductsDesign();
        break;
      case 6:
        onHandleClickSearchProductsSubclass();
        break;
      case 7:
        onHandleClickSearchProductsCategory();
        break;
      default:
    }
  }, [value]);
  const handleChangeChoose = (event, newValue) => {
    setTabValueChoose(newValue);
  };

  const handleChooseCommodity = () => {
    setDialogStatus(true);
  };

  // 分类的产品展示
  const columnsTabData = [
    {
      type: 'checkbox',
      width: '100',
      onChange: (a) => {
        if (value === 4) {
          const pageDataIdsSeason = productsListSeason.map((item) => item.id); //当前分页的id数组
          const prevProductsChooseItemDataSeason =
            productsChooseItemDataSeason.filter((item) => {
              //过滤掉当前页的选中列
              return pageDataIdsSeason.indexOf(item.id) === -1;
            });
          let chooseDatasSeason = productsListSeason.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.id);
          });
          chooseDatasSeason.forEach((element) => {
            // element['type']='SEASON';
            element['type'] = element['addType'];
            element['content'] = element['addTypeName'];
          });
          const newListData = [
            ...prevProductsChooseItemDataSeason,
            ...chooseDatasSeason,
          ];
          //将选中的数据a替换老数据
          // setProductsChooseDataIdSeason(a);
          const newIdsData = newListData.map((item) => item.id);
          //将选中的数据a替换老数据
          setProductsChooseDataIdSeason(newIdsData);
          setProductsChooseItemDataSeason(newListData);
          //
        } else if (value === 5) {
          const pageDataIdsDesign = productsListDesign.map((item) => item.id); //当前分页的id数组
          const prevProductsChooseItemDataDesign =
            productsChooseItemDataDesign.filter((item) => {
              //过滤掉当前页的选中列
              return pageDataIdsDesign.indexOf(item.id) === -1;
            });

          let chooseDatasDesign = productsListDesign.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.id);
          });

          chooseDatasDesign.forEach((element) => {
            // element['type']='SUBCLASS';
            element['type'] = element['addType'];
            element['content'] = element['addTypeName'];
          });

          const newListData = [
            ...prevProductsChooseItemDataDesign,
            ...chooseDatasDesign,
          ];
          //将选中的数据a替换老数据
          // setProductsChooseDataIdSubclass(a);
          const newIdsData = newListData.map((item) => item.id);
          //将选中的数据a替换老数据
          setProductsChooseDataIdDesign(newIdsData);
          setProductsChooseItemDataDesign(newListData);
        } else if (value === 6) {
          const pageDataIdsSubclass = productsListSubclass.map(
            (item) => item.id,
          ); //当前分页的id数组
          const prevProductsChooseItemDataSubclass =
            productsChooseItemDataSubclass.filter((item) => {
              //过滤掉当前页的选中列
              return pageDataIdsSubclass.indexOf(item.id) === -1;
            });

          let chooseDatasSubclass = productsListSubclass.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.id);
          });

          chooseDatasSubclass.forEach((element) => {
            // element['type']='SUBCLASS';
            element['type'] = element['addType'];
            element['content'] = element['addTypeName'];
          });

          const newListData = [
            ...prevProductsChooseItemDataSubclass,
            ...chooseDatasSubclass,
          ];
          //将选中的数据a替换老数据
          // setProductsChooseDataIdSubclass(a);
          const newIdsData = newListData.map((item) => item.id);
          //将选中的数据a替换老数据
          setProductsChooseDataIdSubclass(newIdsData);
          setProductsChooseItemDataSubclass(newListData);
        } else if (value === 7) {
          const pageDataIdsCategory = productsListCategory.map(
            (item) => item.id,
          ); //当前分页的id数组
          const prevProductsChooseItemDataCategory =
            productsChooseItemDataCategory.filter((item) => {
              //过滤掉当前页的选中列
              return pageDataIdsCategory.indexOf(item.id) === -1;
            });

          let chooseDatasCategory = productsListCategory.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.id);
          });

          chooseDatasCategory.forEach((element) => {
            element['type'] = 'GENERAL_CATEGORY';
            element['content'] = element['addTypeName'];
          });

          const newListData = [
            ...prevProductsChooseItemDataCategory,
            ...chooseDatasCategory,
          ];
          //将选中的数据a替换老数据
          // setProductsChooseDataIdCategory(a);
          const newIdsData = newListData.map((item) => item.id);
          //将选中的数据a替换老数据
          setProductsChooseDataIdCategory(newIdsData);
          setProductsChooseItemDataCategory(newListData);
        } else if (value === 0) {
          const pageDataIdsStyles = productsListStyles.map(
            (item) => item.addTypeName,
          ); //当前分页的id数组
          const prevProductsChooseItemDataStyles =
            productsChooseItemDataStyles.filter((item) => {
              //过滤掉当前页的选中列
              return pageDataIdsStyles.indexOf(item.addTypeName) === -1;
            });

          let chooseDatasStyles = productsListStyles?.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.addTypeName);
          });

          const newListData = [
            ...prevProductsChooseItemDataStyles,
            ...chooseDatasStyles,
          ];
          const newIdsData = newListData.map((item) => item.addTypeName);
          //将选中的数据a替换老数据
          setProductsChooseDataIdStyles(newIdsData);
          setProductsChooseItemDataStyles(newListData);
        } else if (value === 1) {
          const pageDataIdsGoods = productsListGoods.map(
            (item) => item.addTypeName,
          ); //当前分页的id数组
          const prevProductsChooseItemDataGoods =
            productsChooseItemDataGoods.filter((item) => {
              //过滤掉当前页的选中列
              return pageDataIdsGoods.indexOf(item.addTypeName) === -1;
            });
          let chooseDatasGoods = productsListGoods?.filter((fItem) => {
            //当前选中的数据过滤出当前页的数据
            return a.includes(fItem.addTypeName);
          });
          const newListData = [
            ...prevProductsChooseItemDataGoods,
            ...chooseDatasGoods,
          ];
          const newIdsData = newListData.map((item) => item.addTypeName);
          //将选中的数据a替换老数据
          setProductsChooseDataIdGoods(newIdsData);
          setProductsChooseItemDataGoods(newListData);
        }
      },
    },
    {
      // title: '编码',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl01' }),
      // title: value === 0 || value === 1 ? '类型' : 'CODE',
      id: value === 0 || value === 1 ? 'addTypeName' : 'id',
      align: 'center',
      width: 347,
    },
    {
      // title: '名称',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl02' }),
      id: 'name',
      align: 'center',
      width: 347,
      render: (item) => {
        return <Box textAlign="center">{item.name}</Box>;
      },
    },
  ];

  // 系列产品展示
  const columnsSeriesData = [
    {
      type: 'checkbox',
      width: '100',
      onChange: (a) => {
        // if (value === 1) {
        const pageDataIdsSeries = productsListSeries.map(
          (item) => item.addTypeName,
        ); //当前分页的id数组
        const prevProductsChooseItemDataSeries =
          productsChooseItemDataSeries.filter((item) => {
            //过滤掉当前页的选中列
            return pageDataIdsSeries.indexOf(item.addTypeName) === -1;
          });

        let chooseDatasSeries = productsListSeries.filter((fItem) => {
          //当前选中的数据过滤出当前页的数据
          return a.includes(fItem.addTypeName);
        });

        chooseDatasSeries.forEach((element) => {
          // element['type']='SERIES';
          element['type'] = element['addType'];
          element['content'] = element['addTypeName'];
        });

        const newListData = [
          ...prevProductsChooseItemDataSeries,
          ...chooseDatasSeries,
        ];
        //将选中的数据a替换老数据
        // setProductsChooseDataIdSeries(a);
        const newIdsData = newListData.map((item) => item.addTypeName);
        //将选中的数据a替换老数据
        setProductsChooseDataIdSeries(newIdsData);
        setProductsChooseItemDataSeries(newListData);
        return;
        // }
      },
    },
    {
      // title: '编码',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl01' }),
      id: 'name',
      align: 'center',
      width: 347,
    },
    {
      // title: '名称',
      title: formatMessage({ id: 'marketing.scene.holiday.c03.lbl02' }),
      id: 'name',
      align: 'center',
      width: 347,
      render: (item) => {
        return <Box textAlign="center">{item.name}</Box>;
      },
    },
  ];

  // 产品模糊搜索
  const onHandleClickSearchProducts = () => {
    dispatch({
      type: 'couponsSetting/getProducts',
      payload: {
        value: {
          name: productName,
          pageNum: productsPageNum,
          pageSize: productsPageSize,
          sort: null,
        },
      },
    });
  };

  // 系列产品模糊搜索
  const onHandleClickSearchProductsSeries = () => {
    dispatch({
      type: 'couponsSetting/getProductsSeries',
      payload: {
        value: {
          addType: 'SERIES',
          addTypeName: productSeriesNames,
          pageNum: productsPageNumSeries,
          pageSize: productsPageSizeSeries,
          sort: null,
        },
      },
    });
  };

  // 款号商品模糊搜索
  const onHandleClickSearchProductsStyles = () => {
    dispatch({
      type: 'couponsSetting/getProductsStyle',
      payload: {
        value: {
          addType: 'SPU',
          addTypeName: productStylesNames,
          pageNum: productsPageNumSeries,
          pageSize: productsPageSizeSeries,
          sort: null,
        },
      },
    });
  };

  // 货号商品模糊搜索
  const onHandleClickSearchProductsGoods = () => {
    dispatch({
      type: 'couponsSetting/getProductsGoods',
      payload: {
        value: {
          addType: 'MATERIAL_CODE',
          addTypeName: productGoodsNames,
          pageNum: productsPageNumSeries,
          pageSize: productsPageSizeSeries,
          sort: null,
        },
      },
    });
  };

  // 季节产品模糊搜索
  const onHandleClickSearchProductsSeason = () => {
    dispatch({
      type: 'couponsSetting/getProductsSeason',
      payload: {
        value: {
          addType: 'SEASON',
          addTypeName: productSeasonNames,
          pageNum: productsPageNumSeason,
          pageSize: productsPageSizeSeason,
          sort: null,
        },
      },
    });
  };

  // 配件产品模糊搜索
  const onHandleClickSearchProductsSubclass = () => {
    dispatch({
      type: 'couponsSetting/getProductsSubclass',
      payload: {
        value: {
          addType: 'SUBCLASS',
          addTypeName: productSubclassNames,
          pageNum: productsPageNumSeason,
          pageSize: productsPageSizeSeason,
          sort: null,
        },
      },
    });
  };
  // 款式模糊搜索------------
  const onHandleClickSearchProductsDesign = () => {
    dispatch({
      type: 'couponsSetting/getProductsDesign',
      payload: {
        value: {
          addType: 'STYLE',
          addTypeName: productDesignNames,
          pageNum: productsPageNumDesign,
          pageSize: productsPageSizeDesign,
          sort: null,
        },
      },
    });
  };

  // 分类产品模糊搜索
  const onHandleClickSearchProductsCategory = () => {
    dispatch({
      type: 'couponsSetting/getProductsCategory',
      payload: {
        value: {
          addType: 'GENERAL_CATEGORY',
          addTypeName: productCategoryName,
          pageNum: productsPageNumCategory,
          pageSize: productsPageSizeCategory,
          sort: null,
        },
      },
    });
  };

  const productsContent = () => {
    return (
      <Box>
        {/* 款式产品 */}
        <TabPanel value={value} index={0} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <Controller
                render={(pr) => (
                  <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                    <Input
                      placeholder="请输入款号名称"
                      id="standard-adornment-password"
                      type="text"
                      value={pr.value ?? productStylesNames}
                      // ref={productsNameStylesRef}
                      onChange={(e) => {
                        // productsNameStylesRef.current = e.target.value;
                        setProductStylesNames(e.target.value);
                        return pr.onChange(e.target.value);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => onHandleClickSearchProductsStyles()}
                            // onMouseDown={handleMouseDownPassword}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                )}
                control={control}
                name=""
              />
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            <DataTableNativeML
              paging={true}
              columns={columnsTabData}
              data={productsListStyles}
              columnKey="addTypeName"
              total={productsTotalStyles}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataStyles}
              page={{
                pageSize: Math.abs(productsPageSizeStyles),
                pageNum: Math.abs(productsPageNumStyles),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageStyles',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        {/* 货号产品 */}
        <TabPanel value={value} index={1} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <Controller
                render={(pr) => (
                  <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                    <Input
                      placeholder="请输入货号名称"
                      id="standard-adornment-password"
                      type="text"
                      value={pr.value ?? productGoodsNames}
                      // ref={productsNameGoodsRef}
                      onChange={(e) => {
                        // productsNameGoodsRef.current = e.target.value;
                        setProductGoodsNames(e.target.value);
                        return pr.onChange(e.target.value);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={onHandleClickSearchProductsGoods}
                            // onMouseDown={handleMouseDownPassword}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                )}
                control={control}
                name=""
              />
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            <DataTableNativeML
              paging={true}
              columns={columnsTabData}
              data={productsListGoods}
              columnKey="addTypeName"
              total={productsTotalGoods}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataGoods}
              page={{
                pageSize: Math.abs(productsPageSizeGoods),
                pageNum: Math.abs(productsPageNumGoods),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageGoods',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={2} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                <Input
                  id="standard-adornment-password"
                  type="text"
                  placeholder={'请输入商品名称'}
                  value={productName}
                  // defaultValue={productsNameRef.current}
                  // ref={productsNameRef}
                  onChange={(e) => setProductName(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => onHandleClickSearchProducts()}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            {/* 产品NO */}
            <DataTableNativeML
              paging={true}
              columns={columns}
              data={productsList}
              columnKey="id"
              total={productsTotal}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdData}
              page={{
                pageSize: Math.abs(productsPageSize),
                pageNum: Math.abs(productsPageNum),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPage',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={3} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                <Input
                  id="standard-adornment-password"
                  type="text"
                  value={productSeriesNames}
                  // ref={productsNameSeriesRef}
                  onChange={(e) => setProductSeriesNames(e.target.value)}
                  placeholder={'请输入系列名称'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => onHandleClickSearchProductsSeries()}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            {/* tab产品 */}
            <DataTableNativeML
              paging={true}
              columns={columnsSeriesData}
              data={productsListSeries}
              columnKey="addTypeName"
              total={productsTotalSeries}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataSeries}
              page={{
                pageSize: Math.abs(productsPageSizeSeries),
                pageNum: Math.abs(productsPageNumSeries),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageSeries',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={4} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                <Input
                  id="standard-adornment-password"
                  type="text"
                  // defaultValue={productsNameSeasonRef.current}
                  // ref={productsNameSeasonRef}
                  value={productSeasonNames}
                  onChange={(e) => setProductSeasonNames(e.target.value)}
                  placeholder="请输入季节名称"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => onHandleClickSearchProductsSeason()}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            <DataTableNativeML
              paging={true}
              columns={columnsTabData}
              data={productsListSeason}
              columnKey="id"
              total={productsTotalSeason}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataSeason}
              page={{
                pageSize: Math.abs(productsPageSizeSeason),
                pageNum: Math.abs(productsPageNumSeason),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageSeason',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={5} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                <Input
                  id="standard-adornment-password"
                  type="text"
                  placeholder="请输入款式名称"
                  value={productDesignNames}
                  // ref={productsNameSubclassRef}
                  onChange={(e) => setProductDesignNames(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => onHandleClickSearchProductsDesign()}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            <DataTableNativeML
              paging={true}
              columns={columnsTabData}
              data={productsListDesign}
              columnKey="id"
              total={productsTotalDesign}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataDesign}
              page={{
                pageSize: Math.abs(productsPageSizeDesign),
                pageNum: Math.abs(productsPageNumDesign),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageDesign',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={6} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                <Input
                  id="standard-adornment-password"
                  type="text"
                  placeholder="请输入品类 名称"
                  value={productSubclassNames}
                  // ref={productsNameSubclassRef}
                  onChange={(e) => setProductSubclassNames(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => onHandleClickSearchProductsSubclass()}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            <DataTableNativeML
              paging={true}
              columns={columnsTabData}
              data={productsListSubclass}
              columnKey="id"
              total={productsTotalSubclass}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataSubclass}
              page={{
                pageSize: Math.abs(productsPageSizeSubclass),
                pageNum: Math.abs(productsPageNumSubclass),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageSubclass',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={7} className="init-tabs-wrap">
          <Box display="flex" justifyContent="flex-end">
            <Box width="261px">
              <FormControl sx={{ m: 1, width: '100%' }} variant="standard">
                <Input
                  id="standard-adornment-password"
                  type="text"
                  placeholder="请输入大类名称"
                  value={productCategoryName}
                  // ref={productsNameCategoryRef}
                  onChange={(e) => setProductCategoryName(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => onHandleClickSearchProductsCategory()}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="table-dialog-width-style">
            <DataTableNativeML
              paging={true}
              columns={columnsTabData}
              data={productsListCategory}
              columnKey="id"
              total={productsTotalCategory}
              devicesMinWidth="794"
              chooseIds={productsChooseItemShowIdDataCategory}
              page={{
                pageSize: Math.abs(productsPageSizeCategory),
                pageNum: Math.abs(productsPageNumCategory),
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              changePage={(data) => {
                dispatch({
                  type: 'couponsSetting/setProductsPageCategory',
                  payload: {
                    value: {
                      pageNum: data.pageNum,
                      pageSize: data.pageSize,
                    },
                  },
                });
              }}
            />
          </Box>
        </TabPanel>
        {/* 款式产品 */}
      </Box>
    );
  };

  const onCloseDialog = (data) => {
    if (data) {
      setProductsChooseItemShowData(productsChooseItemData);
      setProductsChooseItemShowIdData(productsChooseDataId);
      setProductsChooseItemShowDataSeries(productsChooseItemDataSeries);
      setProductsChooseItemShowIdDataSeries(productsChooseDataIdSeries);
      setProductsChooseItemShowDataStyles(productsChooseItemDataStyles);
      setProductsChooseItemShowIdDataStyles(productsChooseDataIdStyles);
      setProductsChooseItemShowDataGoods(productsChooseItemDataGoods);
      setProductsChooseItemShowIdDataGoods(productsChooseDataIdGoods);
      setProductsChooseItemShowDataSeason(productsChooseItemDataSeason);
      setProductsChooseItemShowIdDataSeason(productsChooseDataIdSeason);
      setProductsChooseItemShowDataSubclass(productsChooseItemDataSubclass);
      setProductsChooseItemShowIdDataSubclass(productsChooseDataIdSubclass);
      setProductsChooseItemShowDataDesign(productsChooseItemDataDesign);
      setProductsChooseItemShowIdDataDesign(productsChooseDataIdDesign);
      setProductsChooseItemShowDataCategory(productsChooseItemDataCategory);
      setProductsChooseItemShowIdDataCategory(productsChooseDataIdCategory);
      // }
    } else {
      setProductsChooseItemData(productsChooseItemShowData);
      setProductsChooseDataId(productsChooseItemShowIdData);
      setProductsChooseItemDataSeries(productsChooseItemShowDataSeries);
      setProductsChooseDataIdSeries(productsChooseItemShowIdDataSeries);
      setProductsChooseItemDataStyles(productsChooseItemShowDataStyles);
      setProductsChooseDataIdStyles(productsChooseItemShowIdDataStyles);
      setProductsChooseItemDataGoods(productsChooseItemShowDataGoods);
      setProductsChooseDataIdGoods(productsChooseItemShowIdDataGoods);
      setProductsChooseItemDataSeason(productsChooseItemShowDataSeason);
      setProductsChooseDataIdSeason(productsChooseItemShowIdDataSeason);
      setProductsChooseItemDataSubclass(productsChooseItemShowDataSubclass);
      setProductsChooseDataIdSubclass(productsChooseItemShowIdDataSubclass);
      setProductsChooseItemDataDesign(productsChooseItemShowDataDesign);
      setProductsChooseDataIdDesign(productsChooseItemShowIdDataDesign);
      setProductsChooseItemDataCategory(productsChooseItemShowDataCategory);
      setProductsChooseDataIdCategory(productsChooseItemShowIdDataCategory);
    }
    setDialogStatus(false);
  };

  //点击删除已经选中的商品
  const handleDeleteProducts = (id) => {
    const prevProductsChooseDataId = productsChooseDataId.filter((item) => {
      return item !== id;
    });
    const prevProductsChooseItemData = productsChooseItemData.filter((item) => {
      return item.id !== id;
    });
    const prevProductsChooseItemShowData = productsChooseItemShowData.filter(
      (item) => {
        return item.id !== id;
      },
    );
    const prevProductsChooseItemShowIdData =
      productsChooseItemShowIdData.filter((item) => {
        return item !== id;
      });
    setProductsChooseDataId(prevProductsChooseDataId);
    setProductsChooseItemData(prevProductsChooseItemData);
    setProductsChooseItemShowData(prevProductsChooseItemShowData);
    setProductsChooseItemShowIdData(prevProductsChooseItemShowIdData);
    // setValue(
    //   'goodsProduct',
    //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
    //     ? JSON.stringify(prevProductsChooseItemShowData)
    //     : '',
    // );
  };

  const [seriesPage, setSeriesPage] = useState(1);
  const [productPage, setProductPage] = useState(1);
  const [stylesPage, setStylesPage] = useState(1);
  const [goodsPage, setGoodsPage] = useState(1);
  const [seasonPage, setSeasonPage] = useState(1);
  const [subclassPage, setSubclassPage] = useState(1);
  const [designPage, setDesignPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);

  // 展示的数据
  const showColumns = [
    {
      title: 'SKU',
      id: 'productNo',
      align: 'center',
      width: 150,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt79' }),
      id: 'name',
      align: 'center',
      width: 460,
    },
    {
      // title: '操作',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl07' }),
      align: 'center',
      id: 'details',
      width: 100,
      render: (items) => {
        return (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              lineHeight: '64px',
            }}
          >
            <div
              style={{
                display: 'flex',
                lineHeight: '64px',
                cursor: 'pointer',
              }}
            >
              <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
                <IconButton>
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color: opt === 'detail' ? 'darkgray' : '#525CA3',
                    }}
                    onClick={() => {
                      opt !== 'detail' && handleDeleteProducts(items.id);
                    }}
                  ></DeleteForeverOutlinedIcon>
                </IconButton>
              </ButtonTip>
            </div>
          </div>
        );
      },
    },
  ];

  //计算总页数
  const initPageSize = (num) => {
    return Math.ceil(num / 10);
  };

  //产品的分页
  const handleProductPrevious = () => {
    productPage > 1 && setProductPage(productPage - 1);
  };
  const handleProductDown = () => {
    productsChooseItemShowData.length - productPage * 10 > 0 &&
      setProductPage(productPage + 1);
  };

  // 系列产品的分页
  const handleSeriesPrevious = () => {
    seriesPage > 1 && setSeriesPage(seriesPage - 1);
  };
  const handleSeriesDown = () => {
    productsChooseItemShowDataSeries.length - seriesPage * 10 > 0 &&
      setSeriesPage(seriesPage + 1);
  };

  // 款号产品的分页
  const handleStylesPrevious = () => {
    stylesPage > 1 && setStylesPage(stylesPage - 1);
  };
  const handleStylesDown = () => {
    productsChooseItemShowDataStyles.length - stylesPage * 10 > 0 &&
      setStylesPage(stylesPage + 1);
  };
  // 货号产品的分页
  const handleGoodsPrevious = () => {
    goodsPage > 1 && setGoodsPage(goodsPage - 1);
  };
  const handleGoodsDown = () => {
    productsChooseItemShowDataGoods?.length - goodsPage * 10 > 0 &&
      setGoodsPage(goodsPage + 1);
  };

  // 季节产品的分页
  const handleSeasonPrevious = () => {
    seasonPage > 1 && setSeasonPage(seasonPage - 1);
  };
  const handleSeasonDown = () => {
    productsChooseItemShowDataSeason?.length - seasonPage * 10 > 0 &&
      setSeasonPage(seasonPage + 1);
  };

  // 大类产品的分页
  const handleSubclassPrevious = () => {
    subclassPage > 1 && setSubclassPage(subclassPage - 1);
  };
  const handleSubclassDown = () => {
    productsChooseItemShowDataSubclass?.length - subclassPage * 10 > 0 &&
      setSubclassPage(subclassPage + 1);
  };
  // 款式的分页
  const handleDesignPrevious = () => {
    designPage > 1 && setDesignPage(designPage - 1);
  };
  const handleDesignDown = () => {
    productsChooseItemShowDataDesign?.length - designPage * 10 > 0 &&
      setDesignPage(designPage + 1);
  };

  // 品类产品的分页
  const handleCategoryPrevious = () => {
    categoryPage > 1 && setCategoryPage(categoryPage - 1);
  };
  const handleCategoryDown = () => {
    productsChooseItemShowDataCategory?.length - categoryPage * 10 > 0 &&
      setCategoryPage(categoryPage + 1);
  };

  //计算当前分页的列表
  const initDataTables = (list, page) => {
    const newList = list ?? [];
    const startPage = page > 1 ? (page - 1) * 10 : 0;
    const endPage = 10;
    const data = [...newList].splice(startPage, endPage);
    return data;
  };

  //点击删除已经选中的
  const handleDeleteProductsSeries = (addTypeName) => {
    if (valueChoose === 3) {
      const prevProductsChooseDataIdSeries = productsChooseDataIdSeries.filter(
        (item) => {
          return item !== addTypeName;
        },
      );
      const prevProductsChooseItemDataSeries =
        productsChooseItemDataSeries.filter((item) => {
          return item.addTypeName !== addTypeName;
        });
      const prevProductsChooseItemShowDataSeries =
        productsChooseItemShowDataSeries.filter((item) => {
          return item.addTypeName !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataSeries =
        productsChooseItemShowIdDataSeries.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdSeries(prevProductsChooseDataIdSeries);
      setProductsChooseItemDataSeries(prevProductsChooseItemDataSeries);
      setProductsChooseItemShowDataSeries(prevProductsChooseItemShowDataSeries);
      setProductsChooseItemShowIdDataSeries(
        prevProductsChooseItemShowIdDataSeries,
      );
      // setValue(
      //   'goodsSeries',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataSeries)
      //     : '',
      // );
      return;
    } else if (valueChoose === 4) {
      const prevProductsChooseDataIdSeason = productsChooseDataIdSeason.filter(
        (item) => {
          return item !== addTypeName;
        },
      );
      const prevProductsChooseItemDataSeason =
        productsChooseItemDataSeason.filter((item) => {
          return item.id !== addTypeName;
        });
      const prevProductsChooseItemShowDataSeason =
        productsChooseItemShowDataSeason.filter((item) => {
          return item.id !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataSeason =
        productsChooseItemShowIdDataSeason.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdSeason(prevProductsChooseDataIdSeason);
      setProductsChooseItemDataSeason(prevProductsChooseItemDataSeason);
      setProductsChooseItemShowDataSeason(prevProductsChooseItemShowDataSeason);
      setProductsChooseItemShowIdDataSeason(
        prevProductsChooseItemShowIdDataSeason,
      );
      // setValue(
      //   'goodsSeason',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataSeason)
      //     : '',
      // );
      return;
    } else if (valueChoose === 5) {
      const prevProductsChooseDataIdDesign = productsChooseDataIdDesign.filter(
        (item) => {
          return item !== addTypeName;
        },
      );
      const prevProductsChooseItemDataDesign =
        productsChooseItemDataDesign.filter((item) => {
          return item.index !== addTypeName;
        });
      const prevProductsChooseItemShowDataDesign =
        productsChooseItemShowDataDesign.filter((item) => {
          return item.id !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataDesign =
        productsChooseItemShowIdDataDesign.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdDesign(prevProductsChooseDataIdDesign);
      setProductsChooseItemDataDesign(prevProductsChooseItemDataDesign);
      setProductsChooseItemShowDataDesign(prevProductsChooseItemShowDataDesign);
      setProductsChooseItemShowIdDataDesign(
        prevProductsChooseItemShowIdDataDesign,
      );
      // setValue(
      //   'goodsSubclass',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataSubclass)
      //     : '',
      // );
      return;
    } else if (valueChoose === 6) {
      const prevProductsChooseDataIdSubclass =
        productsChooseDataIdSubclass.filter((item) => {
          return item !== addTypeName;
        });
      const prevProductsChooseItemDataSubclass =
        productsChooseItemDataSubclass.filter((item) => {
          return item.index !== addTypeName;
        });
      const prevProductsChooseItemShowDataSubclass =
        productsChooseItemShowDataSubclass.filter((item) => {
          return item.id !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataSubclass =
        productsChooseItemShowIdDataSubclass.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdSubclass(prevProductsChooseDataIdSubclass);
      setProductsChooseItemDataSubclass(prevProductsChooseItemDataSubclass);
      setProductsChooseItemShowDataSubclass(
        prevProductsChooseItemShowDataSubclass,
      );
      setProductsChooseItemShowIdDataSubclass(
        prevProductsChooseItemShowIdDataSubclass,
      );
      // setValue(
      //   'goodsSubclass',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataSubclass)
      //     : '',
      // );
      return;
    } else if (valueChoose === 7) {
      const prevProductsChooseDataIdCategory =
        productsChooseDataIdCategory.filter((item) => {
          return item !== addTypeName;
        });
      const prevProductsChooseItemDataCategory =
        productsChooseItemDataCategory.filter((item) => {
          return item.id !== addTypeName;
        });
      const prevProductsChooseItemShowDataCategory =
        productsChooseItemShowDataCategory.filter((item) => {
          return item.id !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataCategory =
        productsChooseItemShowIdDataCategory.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdCategory(prevProductsChooseDataIdCategory);
      setProductsChooseItemDataCategory(prevProductsChooseItemDataCategory);
      setProductsChooseItemShowDataCategory(
        prevProductsChooseItemShowDataCategory,
      );
      setProductsChooseItemShowIdDataCategory(
        prevProductsChooseItemShowIdDataCategory,
      );
      // setValue(
      //   'goodsCategory',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataCategory)
      //     : '',
      // );
      return;
    } else if (valueChoose === 0) {
      const prevProductsChooseDataIdStyles = productsChooseDataIdStyles.filter(
        (item) => {
          return item !== addTypeName;
        },
      );
      const prevProductsChooseItemDataStyles =
        productsChooseItemDataStyles.filter((item) => {
          return item.addTypeName !== addTypeName;
        });
      const prevProductsChooseItemShowDataStyles =
        productsChooseItemShowDataStyles.filter((item) => {
          return item.addTypeName !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataStyles =
        productsChooseItemShowIdDataStyles.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdStyles(prevProductsChooseDataIdStyles);
      setProductsChooseItemDataStyles(prevProductsChooseItemDataStyles);
      setProductsChooseItemShowDataStyles(prevProductsChooseItemShowDataStyles);
      setProductsChooseItemShowIdDataStyles(
        prevProductsChooseItemShowIdDataStyles,
      );
      // setValue(
      //   'goodsCategory',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataStyles)
      //     : '',
      // );
      return;
    } else if (valueChoose === 1) {
      const prevProductsChooseDataIdGoods = productsChooseDataIdGoods.filter(
        (item) => {
          return item !== addTypeName;
        },
      );
      const prevProductsChooseItemDataGoods =
        productsChooseItemDataGoods.filter((item) => {
          return item.addTypeName !== addTypeName;
        });
      const prevProductsChooseItemShowDataGoods =
        productsChooseItemShowDataGoods.filter((item) => {
          return item.addTypeName !== addTypeName;
        });
      const prevProductsChooseItemShowIdDataGoods =
        productsChooseItemShowIdDataGoods.filter((item) => {
          return item !== addTypeName;
        });
      setProductsChooseDataIdGoods(prevProductsChooseDataIdGoods);
      setProductsChooseItemDataGoods(prevProductsChooseItemDataGoods);
      setProductsChooseItemShowDataGoods(prevProductsChooseItemShowDataGoods);
      setProductsChooseItemShowIdDataGoods(
        prevProductsChooseItemShowIdDataGoods,
      );
      // setValue(
      //   'goodsGoods',
      //   (productsTypeChooseState ?? deProductsTypeChooseState) === '0'
      //     ? JSON.stringify(prevProductsChooseItemShowDataGoods)
      //     : '',
      // );
      return;
    }
  };

  const showColumnsTabData = [
    {
      title:
        valueChoose === 3 || valueChoose === 0 || valueChoose === 1
          ? formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt80' })
          : 'CODE',
      // id:
      //   valueChoose === 3 || valueChoose === 0 || valueChoose === 1
      //     ? 'addTypeName'
      //     : 'id',
      id:
        valueChoose === 0 || valueChoose === 1
          ? 'addTypeName'
          : valueChoose === 3
          ? 'name'
          : 'id',
      align: 'center',
      width: 150,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt79' }),
      // id:
      //   valueChoose === 3 || valueChoose === 0 || valueChoose === 1
      //     ? 'addTypeName'
      //     : 'name',
      id: 'name',
      align: 'center',
      width: 460,
    },
    {
      // title: '操作',
      title: formatMessage({ id: 'marketing.scene.holiday.c09.lbl07' }),
      align: 'center',
      id: 'details',
      width: 100,
      render: (items) => {
        return (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              lineHeight: '64px',
            }}
          >
            <div
              style={{
                display: 'flex',
                lineHeight: '64px',
                cursor: 'pointer',
              }}
            >
              <ButtonTip title={formatMessage({ id: 'comm.action.btn.04' })}>
                <IconButton>
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color: opt === 'detail' ? 'darkgray' : '#525CA3',
                    }}
                    onClick={() => {
                      opt !== 'detail' &&
                        // handleDeleteProductsSeries(items.addTypeName);
                        handleDeleteProductsSeries(
                          valueChoose === 3 ||
                            valueChoose === 0 ||
                            valueChoose === 1
                            ? items.addTypeName
                            : items.id,
                          1,
                        );
                    }}
                  ></DeleteForeverOutlinedIcon>
                </IconButton>
              </ButtonTip>
            </div>
          </div>
        );
      },
    },
  ];

  const labelCom = (
    <Box className="init-tabs-wrap-style">
      <Box display="flex" justifyContent="space-between">
        <Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl01' })}
              {...a11yProps(0)}
            />
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl02' })}
              {...a11yProps(1)}
            />
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl03' })}
              {...a11yProps(2)}
            />
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl04' })}
              {...a11yProps(3)}
            />
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl05' })}
              {...a11yProps(4)}
            />
            <Tab className="init-tab-style" label="款式" {...a11yProps(5)} />
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl06' })}
              {...a11yProps(6)}
            />
            <Tab
              className="init-tab-style"
              label={formatMessage({ id: 'marketing.scene.holiday.d02.lbl07' })}
              {...a11yProps(7)}
            />
          </Tabs>
        </Box>
        {onCloseDialog ? (
          <IconButton aria-label="close" onClick={() => onCloseDialog()}>
            <CloseIcon className="coupon-dialog-close-icon-style" />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );

  const storesImportClick = () => {
    setBatchImportOpen(true);
  };
  //打开关闭批量导入dialog
  const onCloseBatchImportDialog = () => {
    setBatchImportOpen(false);
    setImportStatus('ready');
    setUploadSuccessData();
  };
  //批量导入的内容部分
  const batchImportContent = () => {
    return (
      <Loading loading={importFetchStatus}>
        <Box gap="16px 0" display="flex" flexDirection="column">
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              1
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              根据标准模板格式填写信息，前往
              <span
                style={{
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={handleDownloadExcelTemplate}
              >
                下载模板{'>'}
                {'>'}
              </span>
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '32px',
                height: '32px',
                fontSize: '16px',
                color: '#ffffff',
                background: theme.palette.primary.main,
                borderRadius: '50%',
                textAlign: 'center',
                lineHeight: '32px',
                marginRight: '10px',
              }}
            >
              2
            </Box>
            <Box sx={{ fontSize: '16px', color: '#212121' }}>
              点击上传文件按钮，上传后系统将对文件内容进行检查
            </Box>
          </Box>
          {importStatus !== 'ready' && (
            <Box
              sx={{
                border:
                  importStatus === 'success'
                    ? '2px solid #4CAF50'
                    : importStatus === 'warning'
                    ? '2px solid #FF9800'
                    : '2px solid #FF3B30',
                borderRadius: '5px',
                padding: '12px 24px',
                marginBottom: importStatus === 'fail' ? '16px' : 0,
              }}
            >
              <Box
                sx={{
                  height: '22px',
                  lineHeight: '22px',
                  fontSize: '16px',
                  color:
                    importStatus === 'success'
                      ? '#4CAF50'
                      : importStatus === 'warning'
                      ? '#FF9800'
                      : '#FF3B30',
                }}
              >
                {importStatus === 'success' ? (
                  '文件上传成功'
                ) : importStatus === 'warning' ? (
                  <>
                    文件内容校验异常，点我
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        cursor: 'pointer',
                      }}
                      onClick={handleDownloadExcelFailData}
                    >
                      下载文件{'>'}
                      {'>'}
                    </span>
                  </>
                ) : (
                  '文件上传失败'
                )}
              </Box>
              <Box
                sx={{
                  lineHeight: '22px',
                  fontSize: '16px',
                  color: '#212121',
                  marginTop: '8px',
                }}
              >
                {importStatus === 'success' ? (
                  `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。`
                ) : importStatus === 'warning' ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。<br />你可以下载未上传成功的数据`,
                    }}
                  />
                ) : (
                  '请下载模板，按照指定方式上传！'
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Loading>
    );
  };
  //批量导入底部按钮自定义
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: '0 32px',
          width: '100%',
          marginBottom: '16px',
        }}
      >
        {importStatus === 'ready' && (
          <Button
            sx={{ width: '100px!important' }}
            variant="contained"
            onClick={handleUploadExcel}
          >
            上传文件
          </Button>
        )}
        {(importStatus === 'success' || importStatus === 'warning') && (
          <Button
            sx={{ width: '100px!important' }}
            variant="contained"
            onClick={!importFetchStatus && onContinueBatchImport}
          >
            继续
          </Button>
        )}
        {(importStatus === 'success' || importStatus === 'warning') && (
          <Button
            sx={{
              width: '100px!important',
              color: theme.palette.primary.main,
            }}
            variant="outlined"
            onClick={onCloseBatchImportDialog}
          >
            取消
          </Button>
        )}
      </Box>
    );
    return { buttonNode, isShow: importStatus !== 'fail' };
  };

  //下载模板
  const handleDownloadExcelTemplate = () => {
    download('/common/importGoodsTemplate');
  };

  //上传excel
  const handleUploadExcel = () => {
    inputUploadExcelRef.current.click();
  };

  //批量上传
  const handleFileChange = (e) => {
    let skuProductNo = [];
    let spuAddTypeName = [];
    let materialCodeAddTypeName = [];
    skuProductNo = productsChooseItemShowData?.map((item) => item.productNo);
    spuAddTypeName = productsChooseItemShowDataStyles?.map(
      (item) => item.addTypeName,
    );
    materialCodeAddTypeName = productsChooseItemShowDataGoods?.map(
      (item) => item.addTypeName,
    );
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('materialCode', materialCodeAddTypeName); //货号
    formData.append('spu', spuAddTypeName); //款号
    formData.append('sku', skuProductNo);
    // 上传excel
    uploadExcel(file, formData, '/common/importGoods', (res) => {
      if (res?.code === 0) {
        if (res.data.failNum === 0) {
          setImportStatus('success');
        } else {
          setImportStatus('warning');
        }
        setUploadSuccessData(res.data);
      } else {
        setImportStatus('fail');
      }
      inputUploadExcelRef.current.value = '';
      setImportFetchStatus();
    });
  };
  //点击批量导入的继续按钮
  const onContinueBatchImport = () => {
    //spu款号、materialCode货号、sku
    const { sku, spu, materialCode } = uploadSuccessData;
    const filterSku = sku.filter(
      (item) => !productsChooseDataId.includes(item.id),
    );
    const filterSpu = spu.filter(
      (item) => !productsChooseDataIdStyles.includes(item.addTypeName),
    );
    const filterMaterial = materialCode.filter(
      (item) => !productsChooseDataIdGoods.includes(item.addTypeName),
    );
    const defaultIds = filterSku.map((item) => item.id);
    const defaultIdsStyles = filterSpu.map((item) => item.addTypeName);
    const defaultIdsGoods = filterMaterial.map((item) => item.addTypeName);
    //sku开始
    setProductsChooseDataId([...productsChooseDataId, ...defaultIds]);
    setProductsChooseItemShowIdData([...productsChooseDataId, ...defaultIds]);
    setProductsChooseItemData([...productsChooseItemData, ...filterSku]);
    setProductsChooseItemShowData([
      ...productsChooseItemShowData,
      ...filterSku,
    ]);
    setValue(
      'goodsProduct',
      JSON.stringify([...productsChooseItemShowData, ...filterSku]),
    );
    //sku结束
    //spu开始
    setProductsChooseDataIdStyles([
      ...productsChooseDataIdStyles,
      ...defaultIdsStyles,
    ]);
    setProductsChooseItemShowIdDataStyles([
      ...productsChooseItemShowIdDataStyles,
      ...defaultIdsStyles,
    ]);
    setProductsChooseItemDataStyles([
      ...productsChooseItemDataStyles,
      ...filterSpu,
    ]);
    setProductsChooseItemShowDataStyles([
      ...productsChooseItemShowDataStyles,
      ...filterSpu,
    ]);
    setValue(
      'goodsStyles',
      JSON.stringify([...productsChooseItemShowDataStyles, ...filterSpu]),
    );
    //spu结束
    //货号开始
    setProductsChooseDataIdGoods([
      ...productsChooseDataIdGoods,
      ...defaultIdsGoods,
    ]);
    setProductsChooseItemShowIdDataGoods([
      ...productsChooseDataIdGoods,
      ...defaultIdsGoods,
    ]);
    setProductsChooseItemDataGoods([
      ...productsChooseItemDataGoods,
      ...filterMaterial,
    ]);
    setProductsChooseItemShowDataGoods([
      ...productsChooseItemShowDataGoods,
      ...filterMaterial,
    ]);
    setValue(
      'goodsGoods',
      JSON.stringify([...productsChooseItemShowDataGoods, ...filterMaterial]),
    );
    //货号结束
    setBatchImportOpen(false);
    setImportStatus('ready');
    setUploadSuccessData();
  };
  //点击下载批量导入失败的数据
  const handleDownloadExcelFailData = () => {
    const { failFilePath } = uploadSuccessData;
    downLoadPrivateFile(failFilePath);
  };

  return (
    <CommodityRulesStyled theme={theme}>
      <Box display="flex" gap="0 16px" mt={5}>
        <CheckBoxFieldCom
          control={control}
          name="paidAmountCheckbox"
          checkedBoxList={[
            {
              label: '单笔购买',
              value: '1',
            },
          ]}
          setValue={setFormValue}
          getValues={getValues}
          disabled={opt === 'detail'}
        />
        <Box height="40px" position="relative" top="3px" left="-26px">
          <TextFieldCom
            control={control}
            showLabel={false}
            label="有效期_天"
            name="orderAmountLimit"
            isNumber={true}
            isPositiveNumber={true}
            endAdornment={
              <Box color="#000" fontSize="14px">
                元
              </Box>
            }
            isParseInt={true}
            getValues={getValues}
            setValue={setFormValue}
            errors={errors}
            rules={{ required: watch('paidAmountCheckbox'), min: 0 }}
            disabled={opt === 'detail'}
          />
        </Box>
        <span
          style={{
            position: 'relative',
            top: '13px',
            left: '-30px',
            color: '#000',
          }}
        >
          商品可获得
        </span>
      </Box>
      <input
        className="input"
        type="file"
        ref={inputUploadExcelRef}
        hidden
        onChange={(event) => handleFileChange(event)}
        accept={
          ('application/vnd.ms-excel.xlsx',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={hasProductRule}
            onChange={(e) => {
              setHasProductRule(e.target.checked);
            }}
            name="setHasProductRule"
            color="primary"
            // disabled={detail}
            disabled={opt === 'detail'}
          />
        }
        label={formatMessage({ id: 'marketing.scene.holiday.n04.chb04' })}
        className="checkbox-wrap checkbox-radio-disabled-color"
      />
      <Controller
        render={(pr) => (
          <RadioGroup
            aria-label="gender"
            name="customized-radios"
            className="select-wrap checkbox-radio-disabled-color"
            onChange={(e) => {
              setOrderBenefitType(e.target.value);
              return pr.onChange(e.target.value);
            }}
            disabled={opt === 'detail'}
            value={orderBenefitType}
          >
            <div>
              <FormControlLabel
                value="DESIGNATED_GOODS"
                control={<Radio color="primary" disabled={opt === 'detail'} />}
                color="primary"
                label={formatMessage({
                  id: 'marketing.scene.holiday.n04.rdo05',
                })}
              />
            </div>
            <div>
              <FormControlLabel
                value="ALL_GOODS"
                control={<Radio color="primary" disabled={opt === 'detail'} />}
                color="primary"
                label={formatMessage({
                  id: 'marketing.scene.holiday.n04.rdo06',
                })}
              />
            </div>
          </RadioGroup>
        )}
        control={control}
        name="couponUsingThreshold"
      />
      <Box>
        <Button
          className={
            opt === 'detail'
              ? 'add-btn checkbox-radio-disabled-button-color'
              : 'add-btn'
          }
          variant="contained"
          onClick={handleChooseCommodity}
          disabled={opt === 'detail'}
        >
          {/* 添加 */}
          {formatMessage({ id: 'marketing.scene.holiday.n05.btn01' })}
        </Button>
        {opt !== 'detail' && (
          <Button
            variant="contained"
            className="stores-setting-button"
            onClick={storesImportClick}
            sx={{ marginLeft: '24px' }}
          >
            批量导入
          </Button>
        )}
      </Box>

      <Box mt={3.5}>
        <Box width="945px" display="flex">
          <Box className="init-tabs-wrap-style">
            <Tabs
              value={valueChoose}
              onChange={handleChangeChoose}
              aria-label="basic tabs example"
              disabled={opt === 'detail'}
            >
              <Tab
                className="init-tab-style init-tab-style-one"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl01',
                })}
                {...a11yProps(0)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl02',
                })}
                {...a11yProps(1)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl03',
                })}
                {...a11yProps(2)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl04',
                })}
                {...a11yProps(3)}
              />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl05',
                })}
                {...a11yProps(4)}
              />
              <Tab className="init-tab-style" label="款式" {...a11yProps(5)} />
              <Tab
                className="init-tab-style"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl06',
                })}
                {...a11yProps(6)}
              />
              <Tab
                className="init-tab-style init-tab-style-four"
                label={formatMessage({
                  id: 'marketing.scene.holiday.d02.lbl07',
                })}
                {...a11yProps(7)}
              />
            </Tabs>
          </Box>
          <Box flex="1" borderBottom="1px solid #818286"></Box>
        </Box>
        <Box style={{ marginLeft: '24px' }}>
          {/* 款号商品 */}
          <TabPanel
            value={valueChoose}
            index={0}
            className="init-tabs-wrap"
            disabled={opt === 'detail'}
          >
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                data={initDataTables(
                  productsChooseItemShowDataStyles,
                  stylesPage,
                )}
                columnKey="addTypeName"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataStyles?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleStylesPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: stylesPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{stylesPage}页</Box>
                  <Box
                    onClick={handleStylesDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        stylesPage * 10 >=
                        productsChooseItemShowDataStyles?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      productsChooseItemShowDataStyles?.length || 0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          {/* 货号商品 */}
          <TabPanel
            value={valueChoose}
            index={1}
            className="init-tabs-wrap"
            disabled={opt === 'detail'}
          >
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                data={initDataTables(
                  productsChooseItemShowDataGoods,
                  goodsPage,
                )}
                columnKey="addTypeName"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataGoods?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleGoodsPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: goodsPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{goodsPage}页</Box>
                  <Box
                    onClick={handleGoodsDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        goodsPage * 10 >=
                        productsChooseItemShowDataGoods?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      (productsChooseItemShowDataGoods &&
                        productsChooseItemShowDataGoods?.length) ||
                        0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel
            value={valueChoose}
            index={3}
            className="init-tabs-wrap"
            disabled={opt === 'detail'}
          >
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                // data={
                //   dataId ? seriesProductData : productsChooseItemShowDataSeries
                // }
                data={initDataTables(
                  productsChooseItemShowDataSeries,
                  seriesPage,
                )}
                columnKey="addTypeName"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataSeries?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleSeriesPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: seriesPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{seriesPage}页</Box>
                  <Box
                    onClick={handleSeriesDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        seriesPage * 10 >=
                        productsChooseItemShowDataSeries?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      productsChooseItemShowDataSeries?.length || 0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel
            value={valueChoose}
            index={2}
            className="init-tabs-wrap"
            disabled={opt === 'detail'}
          >
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumns}
                // data={dataId ? skuProductData : productsChooseItemShowData}
                data={initDataTables(productsChooseItemShowData, productPage)}
                columnKey="id"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowData?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleProductPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: productPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{productPage}页</Box>
                  <Box
                    onClick={handleProductDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        productPage * 10 >= productsChooseItemShowData?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共{initPageSize(productsChooseItemShowData?.length || 0)}页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel
            value={valueChoose}
            index={4}
            className="init-tabs-wrap"
            disabled={opt === 'detail'}
          >
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                // data={productsChooseItemShowDataSeason}
                columnKey="id"
                total={100}
                data={initDataTables(
                  productsChooseItemShowDataSeason,
                  seasonPage,
                )}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataSeason?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleSeasonPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: seasonPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{seasonPage}页</Box>
                  <Box
                    onClick={handleSeasonDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        seasonPage * 10 >=
                        productsChooseItemShowDataSeason?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      productsChooseItemShowDataSeason?.length || 0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel value={valueChoose} index={5} className="init-tabs-wrap">
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                // data={productsChooseItemShowDataSubclass}
                data={initDataTables(
                  productsChooseItemShowDataDesign,
                  designPage,
                )}
                columnKey="id"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataDesign?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleDesignPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: designPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{designPage}页</Box>
                  <Box
                    onClick={handleDesignDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        designPage * 10 >=
                        productsChooseItemShowDataDesign?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      productsChooseItemShowDataDesign?.length || 0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel value={valueChoose} index={6} className="init-tabs-wrap">
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                // data={productsChooseItemShowDataSubclass}
                data={initDataTables(
                  productsChooseItemShowDataSubclass,
                  subclassPage,
                )}
                columnKey="id"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataSubclass?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleSubclassPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: subclassPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{subclassPage}页</Box>
                  <Box
                    onClick={handleSubclassDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        subclassPage * 10 >=
                        productsChooseItemShowDataSubclass?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      productsChooseItemShowDataSubclass?.length || 0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel value={valueChoose} index={7} className="init-tabs-wrap">
            <Box
              width="923px"
              p={1}
              border="1px solid #818286"
              borderTop="none"
              borderRadius="3px"
              borderTopLeftRadius="0"
            >
              <DataTableNativeML
                pageButton={false}
                columns={showColumnsTabData}
                // data={productsChooseItemShowDataCategory}
                data={initDataTables(
                  productsChooseItemShowDataCategory,
                  categoryPage,
                )}
                columnKey="id"
                total={100}
                devicesMinWidth="710"
                np={true}
              />
              {productsChooseItemShowDataCategory?.length > 0 && (
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gap="0 12px"
                  mt={1}
                >
                  <Box
                    onClick={handleCategoryPrevious}
                    sx={{
                      cursor: 'pointer',
                      color: categoryPage === 1 ? '#C9C9C9' : 'inherit',
                    }}
                  >
                    上一页
                  </Box>
                  <Box>第{categoryPage}页</Box>
                  <Box
                    onClick={handleCategoryDown}
                    sx={{
                      cursor: 'pointer',
                      color:
                        categoryPage * 10 >=
                        productsChooseItemShowDataCategory?.length
                          ? '#C9C9C9'
                          : 'inherit',
                    }}
                  >
                    下一页
                  </Box>
                  <Box>
                    共
                    {initPageSize(
                      productsChooseItemShowDataCategory?.length || 0,
                    )}
                    页
                  </Box>
                </Box>
              )}
            </Box>
          </TabPanel>
        </Box>
      </Box>

      {/* 新建以后再出现 */}
      <DialogML
        open={dialogStatus}
        title={labelCom}
        minheightinit={480}
        minwidthinit={800}
        describe={productsContent()}
        handleClose={onCloseDialog}
        specilaAlgorithmLabValue={'ok'}
        pageSource="coupon"
      />
      <CouponModal
        couponType={type}
        dialogStatus={couponOpen}
        setDialogStatus={setCouponOpen}
        coupons={commCoupons}
        setCoupons={setCommCoupons}
        couponId={couponIds}
        setModify={setModify}
        setIsSave={setIsSave}
      ></CouponModal>
      {/* 新建时弹出框 */}
      <ChooseCoupon
        dialogStatus={newCouponOpen}
        setDialogStatus={setNewCouponOpen}
        couponId={couponIds}
        setCoupons={setCommCoupons}
        setModify={setModify}
      ></ChooseCoupon>
      <DialogDataML
        open={batchImportOpen}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span style={{ fontSize: '18px', fontWeight: 600 }}>批量上传</span>
            <IconButton
              aria-label="close"
              onClick={() => onCloseBatchImportDialog()}
            >
              <CloseIcon className="coupon-dialog-close-icon-style" />
            </IconButton>
          </Box>
        }
        content={batchImportContent()}
        onClose={onCloseBatchImportDialog}
        button={initButton()}
      />
    </CommodityRulesStyled>
  );
};
